import React, { useEffect, useState } from 'react';
import { Button, DatePicker, Form, Input } from 'antd';
import { GetSPOrders } from '../../../API/GetData';
import dayjs from 'dayjs';
import { AkhirTahun, AwalTahun } from '../../../Components/Global';

const { RangePicker } = DatePicker;

const FilterOrder = ({ dataSource, isLoading, importData, updateData, onUpdateData }) => {

  const [filterForm] = Form.useForm();
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await GetSPOrders('', AwalTahun, AkhirTahun);
      setData(res);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    filterForm.setFieldsValue({
      OrderDate: [dayjs(AwalTahun), dayjs(AkhirTahun)]
    })
  }, [filterForm]);

  useEffect(() => {
    dataSource(data);
    isLoading(loading)
  }, [data, dataSource, isLoading, loading]);

  useEffect(() => {
    if (importData) {
      fetchData();
    }
    if (updateData) {
      fetchData();
      onUpdateData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [importData, updateData]);


  const onFilterData = async (values) => {
    const { OrderDate, OrderQuotation, Department, Sales } = values;

    try {
      setLoading(true);
      const startDate = OrderDate?.[0] ? dayjs(OrderDate[0]).format('YYYY-MM-DD') : AwalTahun;
      const endDate = OrderDate?.[1] ? dayjs(OrderDate[1]).format('YYYY-MM-DD') : AkhirTahun;

      const response = await GetSPOrders('', startDate, endDate);

      const filtered = response.filter(item => {

        const FilterOrderQuotation = !OrderQuotation ||
          item.OrderQuotation === OrderQuotation

        const FilterDepartment = !Department ||
          item.Department === Department

        const FilterSales = !Sales ||
          item.SalesName === Sales

        return FilterOrderQuotation && FilterDepartment && FilterSales;

      });

      setData(filtered);

    } catch (error) {
      console.error('Error filtering data:', error);
    } finally {
      setLoading(false);
    }
  };

  const onResetFilter = () => {
    filterForm.resetFields();
    filterForm.setFieldsValue({
      OrderDate: [dayjs(AwalTahun), dayjs(AkhirTahun)]
    })
    fetchData();
  };


  return (
    <div>

      <Form
        name="filterForm"
        layout="vertical"
        onFinish={onFilterData}
        autoComplete="off"
        form={filterForm}
        className="relative border-2 rounded-md p-4 my-4"
      >
        <p className="absolute -top-3 left-2 bg-white px-2 text-md">Filter Order</p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

          <Form.Item label="Range Order Date" name="OrderDate" className="w-full">
            <RangePicker className="w-full" />
          </Form.Item>

          {/* <Form.Item label="Order Code" name="OrderCode">
            <Input placeholder="Search by Order Code" />
          </Form.Item> */}

          <Form.Item label="Order Quotation" name="OrderQuotation">
            <Input placeholder="Search by Order Quotation" />
          </Form.Item>

          <Form.Item label="Department" name="Department">
            <Input placeholder="Search by Department" />
          </Form.Item>

          <Form.Item label="Sales" name="Sales">
            <Input placeholder="Search by Sales" />
          </Form.Item>

        </div>

        <div className="flex justify-end gap-2">
          <Button type="primary" htmlType="submit">Submit</Button>
          <Button htmlType="button" onClick={onResetFilter}>Cancel</Button>
        </div>
      </Form>

      {/* <TableOrder isFilteredData={data} isLoading={loading} /> */}
    </div>
  )
}

export default FilterOrder;
